import "../Css/Notifications.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CallInfoNotification from "./CallInfoNotification";
import { ListenToEventSource, askNotificationPermission } from "../store/api/CommonFunctions";
import PhoneRingtone from "../content/PhoneRingtone.mp3"
import { Button } from "react-bootstrap";
import TicketNotification from "./TicketNotification";

let notificationArchive = [];
const NotificationArea = () => {

    const history = useHistory();
    let [notifCount, setNotifications] = useState(notificationArchive.length);
    const callInfoNotifs = notificationArchive ? notificationArchive.sort((a, b) => b.ID - a.ID).filter(n => n.Type.includes("callinfo")) : [];
    const ticketNotifications = notificationArchive ? notificationArchive.sort((a, b) => b.ID - a.ID).filter(n => n.Type.includes("NewTicket")) : [];

    const onGetNotify = (notif) => {
        const notifJson = JSON.parse(notif);
        notificationArchive.push(notifJson);
        setNotifications(notificationArchive.length);
        if ('Notification' in window) {
            if (notifJson.Type.includes("callinfo")) {
                const n = new Notification('تماس جدید',
                    {
                        body: notifJson.Name + "\n" + "شماره تماس: " + notifJson.CallNumber,
                        icon: "../content/images/circle.png"
                    });
            }
            else if (notifJson.Type.includes("NewTicket")) {
                const title = notifJson.Type === "NewTicket"?"تیکت جدید":"پاسخ به تیکت";
                const n = new Notification(title,
                    {
                        body: "شناسه تیکت: " + notifJson.TicketID + "\n" + "نام مشتری: " + notifJson.CustomerName,
                        icon: "../content/images/circle.png"
                    });
            }
        }
        else {
            var audio = new Audio(PhoneRingtone);
            audio.play();
        }
    }
    useEffect(() => {
        askNotificationPermission();
        ListenToEventSource(onGetNotify);
    }, []);
    const removeNotification = (id) => {
        notificationArchive = notificationArchive.filter(n => n.ID !== id);
        setNotifications(notificationArchive.length);
    }
    function clearAll() {
        notificationArchive = [];
        setNotifications(0);
    }
    const openProfile = (id, type) => {
        history.push(getDestUrl(id, type));
    }
    function getDestUrl(id, type) {
        let url = "";
        if (type === "customer_callinfo" || type.includes("NewTicket")) {
            url = "/CRM/AddEditCustomer/" + id;
        }
        else if (type === "precustomer_callinfo") {
            url = "/CRM/AddEditPreCustomer/" + id;
        }
        return url;
    }
    return (


        <div className="notificationArea">
            <input type="hidden" readOnly value={notifCount} />
            {callInfoNotifs && Array.isArray(callInfoNotifs) &&
                callInfoNotifs.map((notif, i) =>
                    <CallInfoNotification notif={notif} key={i} remove={removeNotification} openProfile={openProfile} getDestUrl={getDestUrl} />)
            }
            {ticketNotifications &&
                ticketNotifications.map((notif, i) =>
                    <TicketNotification notif={notif} key={i} remove={removeNotification}  openProfile={openProfile} getDestUrl={getDestUrl}/>)
            }
            {notifCount > 0 &&
                <div>
                    <Button variant="info" className="group-Btn-smalll" onClick={clearAll}>پاک کردن همه</Button>
                </div>
            }
        </div>
    )
}
export default NotificationArea;